import { createEvent } from 'effector'

export const init = createEvent()
